import { createSlice } from "@reduxjs/toolkit";
import { getUpdates } from "../../services/courseService";
import { courseActions, completeCourses, setCompletionModalInfo } from "./courseReducer";
import { skillPathActions, completeSkillPaths } from "./skillPathReducer";
import { domainActions, completeDomains } from "./domainReducer";
import { launchPadLayoutActions } from "./layoutReducer";
import { getUtcDateTime } from "@sf-core";

const dateNow = getUtcDateTime(new Date());
const dataSlice = createSlice({
  name: "dataRefresh",
  initialState: { lastUpdated: dateNow },
  reducers: {
    setLastUpdated(state, action) {
      state.lastUpdated = action.payload;
    },
  },
});

export const getLastestUpdates = () => {
  return async (dispatch, getState) => {
    const { dataRefresh } = getState();
    let response = await getUpdates(dataRefresh.lastUpdated);
    let updates = response.data;

    if (!updates || updates.length == 0) return;

    if (updates.timeStamp) {
      dispatch(dataActions.setLastUpdated(updates.timeStamp));
    }

    if (updates.inProgressCourses.length !== 0) {
      dispatch(courseActions.updateCourses(updates.inProgressCourses));
    }

    if (updates.completedCourses.length !== 0) {
      //Change the updates interval to Default(30s) when a completed course is received
      dispatch(launchPadLayoutActions.setState({ updatesOnDemandInterval: false }));
      dispatch(completeCourses(updates.completedCourses));
    }

    if (updates.completedCoursesInfo.length !== 0) {
      dispatch(setCompletionModalInfo(updates.completedCoursesInfo));
    }

    if (updates.completedAcademySkillPaths.length !== 0) {
      dispatch(completeSkillPaths(updates.completedAcademySkillPaths));
    }

    if (updates.updatedAcademySkillPaths.length !== 0) {
      dispatch(
        skillPathActions.updateSkillPaths(updates.updatedAcademySkillPaths)
      );
    }

    if (updates.completedDomains.length !== 0) {
      dispatch(completeDomains(updates.completedDomains));
    }

    if (updates.updatedDomains.length !== 0) {
      dispatch(domainActions.updateDomains(updates.updatedDomains));
    }
  };
};

export const dataActions = dataSlice.actions;

export default dataSlice.reducer;
